// All times come from the API as UTC ISO strings and are shown in the
// viewer's own time zone and locale.

const DAY_MS = 86_400_000

function startOfDay(date) {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

export function formatTime(iso) {
  return new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(new Date(iso))
}

// "Today", "Tomorrow", "Yesterday" or "Thu, Oct 9".
export function formatDay(iso, now = new Date()) {
  const diff = Math.round((startOfDay(iso) - startOfDay(now)) / DAY_MS)
  if (diff === 0) return 'Today'
  if (diff === 1) return 'Tomorrow'
  if (diff === -1) return 'Yesterday'
  return new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(iso))
}

export function formatDate(iso) {
  return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(iso))
}

// "Oct 7 – 9", "Oct 30 – Nov 2" or "Oct 7".
export function formatDateRange(startIso, endIso) {
  const start = new Date(startIso)
  const fmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' })
  if (!endIso) return fmt.format(start)
  const end = new Date(endIso)
  if (startOfDay(start).getTime() === startOfDay(end).getTime()) return fmt.format(start)
  return fmt.formatRange(start, end)
}

const UNITS = [
  ['year', 365 * DAY_MS],
  ['month', 30 * DAY_MS],
  ['week', 7 * DAY_MS],
  ['day', DAY_MS],
  ['hour', 3_600_000],
  ['minute', 60_000],
]

// "in 3 days", "2 hours ago", "now".
export function relativeTime(iso, now = new Date()) {
  const diff = new Date(iso).getTime() - now.getTime()
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })
  for (const [unit, ms] of UNITS) {
    if (Math.abs(diff) >= ms) return rtf.format(Math.round(diff / ms), unit)
  }
  return 'just now'
}

export function viewerTimeZoneName() {
  const parts = new Intl.DateTimeFormat(undefined, { timeZoneName: 'short' }).formatToParts(new Date())
  return parts.find((p) => p.type === 'timeZoneName')?.value ?? 'your time zone'
}

// Full timestamp for title/tooltip text and <time> elements.
export function formatFull(iso) {
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'full', timeStyle: 'short' }).format(new Date(iso))
}
